import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { OrgModel } from 'src/app/models/org.model';
import { nameValidator } from '../../../validators/nameValidator';
import { uniqueProfileNameInOrgValidator } from '../../../validators/uniqueProfileNameInOrgValidator';
import { ConfigModel } from 'src/app/models/config.model';
import { VoiceConfigModel } from 'src/app/models/voice-config.model';

@Component({
  selector: 'app-clone-profile-modal',
  templateUrl: './clone-profile-modal.component.html',
  styleUrls: ['./clone-profile-modal.component.scss']
})

export class CloneProfileModalComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI | undefined;
  @Input() visible = false;
  @Input() profileId = '';
  @Input() profileName = '';
  @Input() currentOrgId: String | null = null;
  @Input() orgs: OrgModel[] = [];
  @Input() profiles: ConfigModel[] | VoiceConfigModel[] = [];

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<any>();

  cloneForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.cloneForm = this.fb.group({
      targetOrganizationId: [null, Validators.required],
      newProfileName: [{ value: null, disabled: false },
        [Validators.required, Validators.minLength(5), Validators.maxLength(20), nameValidator()]]
    },{
      validators: [
        uniqueProfileNameInOrgValidator(
          () => this.profiles,
          undefined,
          "newProfileName",
          "targetOrganizationId",
          false
        )
      ]
    });
  }

  ngOnInit(): void {
    console.log("ngOnInit() ");
  }

  ngOnChanges(): void {
    if (this.profileName) {
      this.cloneForm.patchValue({
        newProfileName: `${this.profileName} - Copy`
      });

      this.cloneForm.updateValueAndValidity();
      this.cloneForm.markAllAsTouched();
    }
  }

  confirmClone(): void {
    console.log("confirmClone()")
    if (this.cloneForm.invalid) {
      this.cloneForm.markAllAsTouched();
      return;
    }

    const payload = {
      ...this.cloneForm.value,
      sourceProfileId: this.profileId,
      cloned: true
    };

    this.onClose.emit(payload);
    this.visible = false;
    this.visibleChange.emit(false);
  }

  close(): void {
    console.log("close()")
    this.visible = false;
    this.visibleChange.emit(false);
  }
}